import { IArrival } from '@/coreDomainsModule/entities/arrival';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { EditableProperties, PartialDeliveryRequest } from '@/coreInfrastructureModule/axios/generated/orderManage';

/**
 * UI用の型を発注一括編集のAPIリクエストの型に変換する
 */
export class bulkPutUnpaidOrderedOrderArapter {
  /**
   * IArrivalからEditablePropertiesに変換する
   * @param order - a
   */
  public static adapt = (order: IArrival): EditableProperties => {
    if (order.updateAt == null) {
      console.error('updateAtがありません。');
      throw new Error();
    }
    return {
      orderId: order.arrivalId,
      orderStatus: order.status,
      orderEstimateTimeOfArrival: order.crossDate ? DateService.formatIDateToISOString(order.crossDate) : undefined,
      updateAt: order.updateAt,
      partialDeliveryList:
        order.partialDeliveries?.map((pd): PartialDeliveryRequest => {
          if (!pd.number || !pd.crossDate || !pd.status) {
            throw new Error('分納情報が不正です。');
          }
          return {
            partialDeliveryId: pd.arrivalId,
            partialDeliveryNumber: pd.number.toString(),
            orderAmount: pd.amount,
            deliveryDate: DateService.formatIDateToISOString(pd.crossDate),
            partialDeliveryStatus: pd.status.toString(),
            updatedAt: pd.updateAt,
          };
        }) ?? [],
    };
  };
}
